import React from 'react'
import StyledDiv from './styles'
import { Spinner } from '../Spinner'
import { LiteralsService } from '../../services'

export class PaymentGatewayRedirectOverlay extends React.PureComponent {
  render() {
    return (
      <StyledDiv role='status' aria-live='polite'>
        <Spinner />
        <p>{ LiteralsService.get('redirectingToPaymentGateway', true) }</p>
      </StyledDiv>
    )
  }
}
